export enum SortDirectionEnum {
    ascending = 'ascending',
    descending = 'descending'
}

export enum SortEnum {
    author = 'author',
    date = 'date',
    role = 'role'
}
